'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notification = require('../actions/notification');

var NotificationActions = _interopRequireWildcard(_notification);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case NotificationActions.INIT_NOTIFICATION:
            return action.notificationInfo;

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/notification.js
// module id = 779
// module chunks = 0